import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { auth0Config } from './config/auth0-config';
import { Home } from './components/Home';
import { BrowseView } from './components/BrowseView';
import Profile from './components/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthModeToggle } from './components/AuthModeToggle';
import { SheetSelectionProvider } from './contexts/sheetSelection';
import { ChatsProvider } from './contexts/chats';
import { MessagesProvider } from './providers/messages';
import { isInternalAuthMode } from './utils/auth-mode';

function AppContent() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="min-h-screen bg-peach">
        <ChatsProvider>
          <MessagesProvider>
            <SheetSelectionProvider>
              <ProtectedRoute>
                <div className="flex flex-col min-h-screen">
                  <main className="flex-grow">
                    <Routes>
                      <Route path="/" element={<BrowseView />} />
                      <Route path="/account/:accountId" element={<BrowseView />} />
                      <Route
                        path="/account/:accountId/chat/:chatId"
                        element={<Home />}
                      />
                      <Route path="/account/:accountId/chat/new" element={<Home />} />
                      <Route path="/profile" element={<Profile />} />
                    </Routes>
                  </main>
                </div>
              </ProtectedRoute>
            </SheetSelectionProvider>
          </MessagesProvider>
        </ChatsProvider>
      </div>
      <AuthModeToggle />
    </Router>
  );
}

function App() {
  if (isInternalAuthMode()) {
    return <AppContent />;
  }

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        ...auth0Config.authorizationParams,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={(appState) => {
        window.history.replaceState({}, document.title, appState?.returnTo || '/');
      }}
    >
      <AppContent />
    </Auth0Provider>
  );
}

export default App;
